interface Props {
  reportData: any;
  name: any;
}

const ReportPreview = ({ reportData, name }: Props) => {
  return (
    <div
      className="bg-white p-8 w-full mx-auto border rounded shadow-md text-sm text-gray-800"
      id="report-content"
    >
      {/* Company Header */}
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-gray-900">TTM4U Pvt. Ltd.</h1>
        <p className="text-sm text-gray-600">
          12455 Mesquite st , OAK HILLS CA 92344
        </p>
        <p className="text-sm text-gray-600">
          Email: support@ttm4u.com | Phone: +1 (707) 761-7464
        </p>
      </div>

      {/* Report Title */}
      {/* <div className="mb-6 border-b pb-2">
        <h2 className="text-xl font-semibold text-gray-800">
          Driver Report Details
        </h2>
      </div> */}

      {/* Report Key-Value Table */}
      {reportData?.data?.map((sec: any, ind: number) => {
        const { userId, sections } = sec;

        return (
          <div key={ind}>
            <div className="bg-gray-100 text-indigo-500 border b-gray-700 p-3 font-bold">
              {name} Id #{userId}
            </div>
            {sections?.map((sections: any, index: number) => {
              const { title, columns, sectionId } = sections;
              return (
                <div key={index} className="border b-gray-700 mb-3">
                  <h3 className="border-b p-2 bg-gray-100 font-bold">
                    {title}
                  </h3>
                  {columns?.map((items: any, i: number) => {
                    return (
                      <div key={i} className="flex  border-b items-center">
                        <div className="font-medium flex-1 border-r  text-gray-700 px-2 py-1">
                          {items?.label}
                        </div>
                        <div className="text-gray-900  flex-1 px-2 py-1">
                          {items?.value}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
      {/* {reportData?.data?.map((sections: any, index: number) => {
        const { title, columns } = sections;
        return (
          <div className="border b-gray-700 mb-3">
            <h3 className="border-b p-2 bg-gray-100 font-bold">{title}</h3>
            {columns?.map((items: any, i: number) => {
              return (
                <div key={i} className="flex  border-b items-center">
                  <div className="font-medium flex-1 border-r  text-gray-700 px-2 py-1">
                    {items?.label}
                  </div>
                  <div className="text-gray-900  flex-1 px-2 py-1">
                    {items?.value}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })} */}
    </div>
  );
};

export default ReportPreview;
